import { BetterIdCompany } from 'common/types'
import { CompanyOption } from 'views/assets/ManualAssetEntry/ManualAddForm/ManualAddForm.types'

export const groupParentWithChildren = (
  companies: BetterIdCompany[]
): CompanyOption[] => {
  const parentMap: Record<number, CompanyOption[]> = {}

  companies.forEach((company) => {
    const { id, name, parentCompanyId, parentCompanyName } = company

    if (parentCompanyId) {
      parentMap[parentCompanyId] = parentMap[parentCompanyId] || []
      parentMap[parentCompanyId].push({
        id: id!,
        name,
        isChild: true,
        parent: parentCompanyName as string,
        parentId: parentCompanyId,
      })
    } else if (id !== null) {
      parentMap[id] = parentMap[id] || []
    }
  })

  const result: CompanyOption[] = []

  companies.forEach((company) => {
    const { id, name, parentCompanyId } = company

    if (!parentCompanyId && id !== null) {
      result.push({ id, name, isChild: false })

      const children = parentMap[id]
      if (children) {
        result.push(...children)
      }
    }
  })

  Object.keys(parentMap).forEach((parentId) => {
    if (!result.find((company) => company.id === Number(parentId))) {
      result.push({
        id: Number(parentId),
        name: parentMap[Number(parentId)][0].parent as string,
        isChild: false,
      })
      result.push(...parentMap[Number(parentId)])
    }
  })

  return result
}

export const groupParentWithChildrenAndFillNames = (
  companies: BetterIdCompany[]
): CompanyOption[] => {
  const parentMap: Record<number, CompanyOption[]> = {}
  const parentNameMap: Record<number, string> = {}

  companies.forEach((company) => {
    const { id, name, parentCompanyId, parentCompanyName } = company

    if (parentCompanyId) {
      parentMap[parentCompanyId] = parentMap[parentCompanyId] || []
      parentMap[parentCompanyId].push({
        id: id!,
        name,
        isChild: true,
        parent: parentCompanyName as string,
        parentId: parentCompanyId,
      })
    } else if (id !== null) {
      parentMap[id] = parentMap[id] || []
      parentNameMap[id] = name
    }
  })

  const result: CompanyOption[] = []

  companies.forEach((company) => {
    const { id, name, parentCompanyId } = company

    if (!parentCompanyId && id !== null) {
      result.push({ id, name, isChild: false })

      const children = parentMap[id]
      if (children) {
        const childrenWithParentNames = children.map((child) => ({
          ...child,
          parent: child.parent || name,
        }))
        result.push(...childrenWithParentNames)
      }
    }
  })

  // Handle cases where all companies are children and their parents are not explicitly listed
  Object.keys(parentMap).forEach((parentId) => {
    const parentIdNum = Number(parentId)
    if (!result.find((company) => company.id === parentIdNum)) {
      const children = parentMap[parentIdNum]
      const parentName =
        parentNameMap[parentIdNum] || (children[0].parent as string)

      result.push({
        id: parentIdNum,
        name: parentName,
        isChild: false,
      })

      // Add children with proper parent names
      const childrenWithParentNames = children.map((child) => ({
        ...child,
        parent: child.parent || parentName,
      }))
      result.push(...childrenWithParentNames)
    }
  })

  return result
}
